// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1_k7s","imageUploader":"EGiftCard_imageUploader__1H77d"};